var _path, _mask, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuestAccBgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 298,
    viewBox: "0 0 1440 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 231.412V0H0V234.786C107.71 259.052 334.228 297 697.5 297C1078.1 297 1327.89 255.344 1440 231.412Z",
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 297
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 231.412V0H0V234.786C107.71 259.052 334.228 297 697.5 297C1078.1 297 1327.89 255.344 1440 231.412Z",
    fill: "url(#paint1_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1597 195.784C1590.7 187.424 1582.66 180.523 1573.44 175.556C1564.21 170.589 1554.01 167.672 1543.54 167.008C1510.94 166.475 1491.84 193.195 1489.4 196.85C1488.1 198.524 1482.53 204.843 1477.41 204.843C1471.46 203.944 1466.08 200.812 1462.37 196.088C1456.06 187.739 1448.02 180.85 1438.79 175.896C1429.57 170.941 1419.37 168.039 1408.91 167.388C1376.3 167.008 1357.29 193.5 1354.77 197.154C1353.47 198.829 1347.89 205.147 1342.78 205.147C1337.05 204.151 1331.92 201.021 1328.42 196.393C1325.98 193.195 1306.27 167.998 1274.58 167.693C1242.89 167.388 1222.96 193.881 1220.44 197.459C1219.14 199.209 1213.57 205.452 1208.45 205.452C1202.81 204.574 1197.73 201.577 1194.25 197.078L1154 226.843C1157.05 230.878 1176.91 255.467 1207.46 255.772H1208.22C1239.68 255.772 1258.32 230.421 1261.68 225.854C1263.05 224.103 1268.55 217.784 1273.89 218.241C1279.54 219.313 1284.62 222.332 1288.25 226.767C1290.92 230.193 1310.4 255.543 1341.71 255.848H1342.47C1373.93 255.848 1392.57 230.498 1395.93 225.93C1397.3 224.179 1402.8 218.317 1408.15 218.317C1413.79 219.389 1418.87 222.408 1422.5 226.843C1425.02 230.269 1444.65 255.619 1476.34 256H1477.11C1508.57 256 1527.28 230.574 1530.56 226.006C1531.86 224.255 1537.36 218.393 1542.7 218.393C1548.44 219.472 1553.59 222.581 1557.21 227.148L1597 195.784Z",
    fill: "#007CBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M354.494 229.609C355.904 231.178 355.853 233.571 354.378 235.079L353.377 236.103L332.964 256.402L294.959 294.195C293.398 295.747 290.878 295.747 289.318 294.195L270.852 275.833C269.28 274.269 269.28 271.724 270.852 270.16L308.789 232.435C308.812 232.412 308.844 232.399 308.878 232.399C308.99 232.399 309.046 232.262 308.966 232.183L271.212 194.64C269.639 193.075 269.64 190.528 271.216 188.964L289.532 170.788C291.089 169.244 293.599 169.24 295.16 170.781L333.168 208.293L353.581 228.592L354.494 229.609Z",
    fill: "#007CBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.3298 235.767C53.0088 234.184 53.1078 231.856 54.5584 230.39L55.5546 229.384L75.8661 209.155L113.269 171.809C114.826 170.255 117.346 170.249 118.909 171.797L137.136 189.834C138.714 191.396 138.718 193.944 137.145 195.511L99.4133 233.09C99.3899 233.113 99.3583 233.126 99.3253 233.126C99.2138 233.126 99.1583 233.262 99.2376 233.34L136.783 270.406C138.361 271.964 138.371 274.508 136.805 276.077L118.745 294.18C117.189 295.739 114.665 295.747 113.099 294.197L75.3076 256.795L54.996 236.565L54.3298 235.767Z",
    fill: "#007CBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M229.014 189.837C227.453 188.271 224.918 188.268 223.354 189.83L161.842 251.263C160.274 252.828 160.278 255.37 161.85 256.931L180.237 275.188C181.802 276.742 184.329 276.736 185.887 275.174L247.184 213.722C248.741 212.162 248.741 209.636 247.185 208.074L229.014 189.837Z",
    fill: "#007CBE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 231C1327.89 254.932 1078.1 296.588 697.5 296.588C334.228 296.588 107.71 258.639 0 234.374",
    stroke: "#C7EAF5",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 716.5,
    y1: 297,
    x2: 716.5,
    y2: -218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008CD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 716.5,
    y1: 297,
    x2: 716.5,
    y2: -218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008CD7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestAccBgWave);
export default __webpack_public_path__ + "static/media/guest_acc_bg_wave.884f9c90.svg";
export { ForwardRef as ReactComponent };